import { type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "/schedule",
    name: ROUTE_NAME.SCHEDULE,
    component: () => import("./views/ScheduleView.vue"),
  },
];
